import { h, Fragment, Component } from "preact";
import { useMemo, useEffect } from 'preact/hooks'
import { observer } from "mobx-react";
import { withStore } from "@searchspring/snap-preact-components";
import "./Header.css";
import { Tabs } from "../Tabs/Tabs";

function getResultsCountTitle(resultsCount, query) {
  if (!resultsCount || !query) {
    return;
  }

  if (window.Shopify.locale == 'fr') {
		if (resultsCount == 1) {
			return `Recherche: ${resultsCount} résultat trouvé pour "${query}" - ${window.Resources.shop_name}`;
		} else {
			return `Recherche: ${resultsCount} résultats trouvés pour "${query}" - ${window.Resources.shop_name}`;
		}
	} else {
		if (resultsCount == 1) {
			return `Search: ${resultsCount} result found for "${query}" - ${window.Resources.shop_name}`;
		} else {
			return `Search: ${resultsCount} results found for "${query}" - ${window.Resources.shop_name}`;
		}
	}
}

@withStore
@observer
export class Header extends Component {
  render() {
    const { pagination, search } = this.props.store;

    useEffect(() => {
      if (search && search.query) {
        /* Updating the page title and meta tags because the page_title result count mismatches with Searchspring */
        const titleText = getResultsCountTitle(pagination.totalResults, search.query.string);

        const title = document.querySelector('title');
        const ogMetaTag = document.querySelector('meta[property="og:title"]');
        const twitterMetaTag = document.querySelector('meta[name="twitter:title"]');

        if (titleText) {
          if (title) {
            title.textContent = titleText;
          }

          if (ogMetaTag) {
            ogMetaTag.setAttribute('content', titleText);
          }

          if (twitterMetaTag) {
            twitterMetaTag.setAttribute('content', titleText);
          }
        }
      }
    }, [pagination.totalResults]);

    return (
      <>
        {pagination.totalResults === 0 ? (
          <header class="ss-header-container ss-header-results-not-found">
            <h2 class="ss-title ss-results-title ss-no-results-title headline headline-medium">
              {search?.query &&
                <>
                  {window.Resources.searchspring.results.noResultsHeading}
                  <span class="ss-results-query">
                    <br/>{search.query.string}
                  </span>
                  <span class="ss-results-header-body body-medium">
                    {window.Resources.searchspring.results.noResultsCallToAction}
                  </span>
                </>
              }
            </h2>
            <Tabs tabs={this.props.tabs}/>
          </header>
        ) : pagination.totalResults && pagination.totalResults > 0 ? (
          <header class="ss-header-container ss-header-results-found">
            <h2 class="ss-title ss-results-title headline headline-medium">
              {window.Resources.searchspring.results.resultsHeading}
              {search?.query && (
                <span class="ss-results-query">
                  <br/>{search.query.string}
                </span>
              )}
            </h2>
            <Tabs tabs={this.props.tabs}/>
          </header>
        ) : null}
      </>
    )
    
  }
}
